module.exports = __webpack_public_path__ + "img/sort-button-secondary.af0463b4.svg";